import { render } from "./DocumentNavigationItemGroup.vue?vue&type=template&id=f801053c&scoped=true"
import script from "./DocumentNavigationItemGroup.vue?vue&type=script&lang=js"
export * from "./DocumentNavigationItemGroup.vue?vue&type=script&lang=js"

import "./DocumentNavigationItemGroup.vue?vue&type=style&index=0&id=f801053c&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Tomi\\PhpstormProjects\\frontend-v2\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f801053c"]])

export default __exports__